import type { OffersResponse } from '@/api/offers/types';

export const selectHasActivePaymentFreeMonthOffer = (offers: OffersResponse) =>
  Boolean(offers.paymentFreeMonth);
